import UserRecordItem from "./UserRecordItem";

export default UserRecordItem;
